import { Button, Input } from 'antd';
import React, { useState } from 'react';
import { $Formutil, FormItem, useForm, withForm } from 'react-antd-formutil';
import { useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Debug from 'components/Debug';
import Toast from 'components/Toast';
import Track from 'components/Track';
import { getStep } from 'modules/Security/components/Steps';
import store from 'modules/Security/modules/Modify/store';
import { SecurityActionType } from 'modules/Security/type';
import { eventName, eventType, processType } from '../../../helper';

/**
 * 证件号码验证
 */

export interface VerifyIDProps {
    $formutil: $Formutil<{ id_no: string }>;
    type: SecurityActionType;
}

const VerifyID: React.FC<VerifyIDProps> = ({ type }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const $formutil = useForm<{ id_no: string }>();
    const location = useLocation();

    const submit = async () => {
        const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                const resp = await store.verifyId({
                    process: processType[type],
                    id_no: $params.id_no
                });

                const currentStep = getStep(location.pathname);

                // 跳转下一步时step：修改密码时为3，更新密码时为2
                navigate(`../${currentStep + 1}`, { state: { verify_token: resp.data.verify_token } });
            } catch (err) {
                Toast.show(err);

                // 操作超时
                if (err.error_code === 11084) {
                    navigate('../1');
                }
            }

            setLoading(false);
        }
    };

    return (
        <div>
            <p>{__('请填写TradeUP的开户证件号码')}：</p>
            <FormItem
                name="id_no"
                required
                $parser={(viewValue, setViewValue) => setViewValue(viewValue.replace(/\s/g, ''))}
                validMessage={{
                    required: __('请填写开户证件号码')
                }}>
                <Input placeholder={__('请输入开户证件号码')} />
            </FormItem>
            <CardButtonWrap>
                <Track eventModel="安全中心" eventType={eventType[type]} eventName={`${eventName[type]}_下一步2`}>
                    <Button
                        block
                        type="primary"
                        size="large"
                        className="verify-identify-btn"
                        onClick={submit}
                        loading={loading}
                        disabled={!$formutil.$params.id_no}
                        htmlType="submit">
                        {__('下一步')}
                    </Button>
                </Track>
            </CardButtonWrap>

            <Debug data={$formutil.$params} />
        </div>
    );
};

export default withForm(VerifyID);
